module.exports = __webpack_public_path__ + "5264cfe65e70b66cfe300246fbf7ea12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/theMarkerSample.png
// module id = 3263
// module chunks = 0